<div class="step-content">
    <div class="step-header">
        <h2 class="step-title">Paso 1: Información básica</h2>
    </div>

    <form [formGroup]="form" class="row g-4">
        <div class="col-lg-8">
            <!-- Título -->
            <div class="form-group">
                <label class="form-label" [class.required-field]="!isReadonly">Título</label>
                @if (!isReadonly) {
                <input type="text" class="form-control" formControlName="title"
                    placeholder="Ej: Oferta de empleo destacada"
                    [ngClass]="{'is-invalid': form.get('title')?.invalid && form.get('title')?.touched}">
                @if (form.get('title')?.invalid && (form.get('title')?.touched || form.get('title')?.dirty)) {
                @if (form.get('title')?.errors?.['required'] == true) {
                <div class="invalid-feedback">
                    Este campo es requerido
                </div>
                }
                @if (form.get('title')?.hasError('maxlength')) {
                <div class="invalid-feedback">
                    Este campo no puede exceder los {{form.get('title')?.errors?.['maxlength']?.requiredLength}}
                    caracteres
                </div>
                }
                }
                } @else {
                <p class="form-control-plaintext">{{ form.get('title')?.value || '—' }}</p>
                }
            </div>

            <!-- Subtítulo -->
            <div class="form-group">
                <label class="form-label" [class.required-field]="!isReadonly">Subtítulo</label>
                @if (!isReadonly) {
                <input type="text" class="form-control" formControlName="subtitle"
                    placeholder="Ej: Haz que tus ofertas laborales llamen más la atención."
                    [ngClass]="{'is-invalid': form.get('subtitle')?.invalid && form.get('subtitle')?.touched}">
                @if (form.get('subtitle')?.invalid && (form.get('subtitle')?.touched || form.get('subtitle')?.dirty)) {
                @if (form.get('subtitle')?.errors?.['required'] == true) {
                <div class="invalid-feedback">
                    Este campo es requerido
                </div>
                }
                @if (form.get('subtitle')?.hasError('maxlength')) {
                <div class="invalid-feedback">
                    Este campo no puede exceder los {{form.get('subtitle')?.errors?.['maxlength']?.requiredLength}}
                    caracteres
                </div>
                }
                }
                } @else {
                <p class="form-control-plaintext">{{ form.get('subtitle')?.value || '—' }}</p>
                }
            </div>

            <!-- Descripción corta -->
            <div class="form-group">
                <label class="form-label" [class.required-field]="!isReadonly">Descripción corta</label>
                @if (!isReadonly) {
                <textarea class="form-control" rows="3" formControlName="shortDescription"
                    placeholder="Resumen en pocas palabras los beneficios clave de tu servicio."
                    [ngClass]="{'is-invalid': form.get('shortDescription')?.invalid && form.get('shortDescription')?.touched}">
          </textarea>
                @if (form.get('shortDescription')?.invalid && (form.get('shortDescription')?.touched ||
                form.get('shortDescription')?.dirty)) {
                @if (form.get('shortDescription')?.errors?.['required'] == true) {
                <div class="invalid-feedback">
                    Este campo es requerido
                </div>
                }
                @if (form.get('shortDescription')?.hasError('maxlength')) {
                <div class="invalid-feedback">
                    Este campo no puede exceder los
                    {{form.get('shortDescription')?.errors?.['maxlength']?.requiredLength}} caracteres
                </div>
                }
                }
                } @else {
                <p class="form-control-plaintext">{{ form.get('shortDescription')?.value || '—' }}</p>
                }
            </div>

            <!-- Descripción larga -->
            <div class="form-group">
                <label class="form-label">Descripción larga</label>
                @if (!isReadonly) {
                <quill-editor [modules]="quillOptions" formControlName="longDescription" [style]="{height: '200px'}"></quill-editor>
                } @else {
                <div class="border rounded p-2 description-content" [innerHTML]="form.get('longDescription')?.value || '—'"></div>
                }
            </div>
        </div>

        <!-- Vista previa -->
        <div class="col-lg-4">
            <div class="preview-card">
                <h6 class="preview-title">Vista previa</h6>
                <div class="preview-image">
                    @if(coverFileId){
                    <img [src]="fileBaseUrl + '/' + coverFileId" alt="Imagen de portada" class="cover-preview" />
                    } @else if(coverPreview) {
                    <img [src]="coverPreview" alt="Imagen de portada" class="preview-img" />
                    } @else {
                    <span class="preview-placeholder">Imagen de portada</span>
                    }
                </div>
                <div class="preview-content">
                    <h5 class="preview-product-title">
                        {{ form.get('title')?.value || 'Título de tu producto' }}
                    </h5>
                    <p class="preview-subtitle">
                        {{ form.get('subtitle')?.value || 'Subtítulo atractivo' }}
                    </p>
                    <p class="preview-description">
                         {{ form.get('shortDescription')?.value || 'Tu descripción corta aparecerá aquí. Intenta que sea clara y concisa para captar la atención de los clientes potenciales.' }}
                    </p>
                </div>
            </div>
        </div>
    </form>
</div>